import "./TopSection.css";

export const TopSection = () => {
  return (
    <>
      <div className="top-section">
        <div className="isb-logo-container">
          <img src="./assets/isb-logo.png" alt="isb-logo" />
        </div>
        <img
          src="./assets/header-logo.png"
          className="header-logo"
          alt="heder-img"
        />
        <hr />
        <h2>Ulogged In</h2>
      </div>
    </>
  );
};
